<template>
  <!-- form -->
  <validation-observer v-slot="{ invalid, validate }" ref="employeeDetailsValidation">
    <b-form class="mt-2" @submit.prevent>
      <b-row>
        <b-col sm="6">
          <b-form-group label="Department*" label-for="department">
            <validation-provider rules="required" #default="{ errors }" name="department">
              <b-form-select v-model="employementDetail.departmentId" :disabled="!isEdit"
                :options="departmentOptions" :state="errors.length > 0 ? false : null" required />
              <small v-if="errors.length" class="text-danger text-end">{{
                errors[0]
              }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="Designation*" label-for="designation">
            <validation-provider rules="required" #default="{ errors }" name="designation">
              <b-form-select v-model="employementDetail.designationId" :disabled="!isEdit"
                :options="designationOptions" :state="errors.length > 0 ? false : null" required />
              <small v-if="errors.length" class="text-danger text-end">{{
                errors[0]
              }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <!-- <b-col sm="6">
          <b-form-group label="Basic Salary" label-for="basicSalary">
            <validation-provider rules="required" #default="{ errors }" name="basic salary">
              <b-form-input name="basicSalary" placeholder="Basic Salary" :disabled="!employementDetail.isEdit"
                v-model="employementDetail.salary" :state="errors.length > 0 ? false : null" required />
              <small v-if="errors.length" class="text-danger text-end">{{
                errors[0]
              }}</small>
            </validation-provider>
          </b-form-group>
        </b-col> -->
        <b-col sm="6">
  <b-form-group label="Hire Date*" label-for="hireDate">
    <validation-provider rules="required" #default="{ errors }" name="Hire Date">
      <DatePicker 
        v-model="employementDetail.hireDate"
        type="date"
        format="YYYY-MM-DD"
        value-type="YYYY-MM-DD"
        placeholder="Select Hire Date"
        :clearable="false"
        :disabled="!isEdit"
        :state="errors.length > 0 ? false : null"
        :default-value="null"
        :editable="false"
        :disabled-date="disableFutureDates"
      />
      <small v-if="errors.length" class="text-danger text-end">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</b-col>
 

        
        <b-col sm="6">
          <b-form-group label="Reporting Person" label-for="reportingPerson">
            <validation-provider  #default="{ errors }" name="reporting person">
              <b-form-select v-model="employementDetail.managerId" :disabled="!isEdit"
              
                :options="managerOptions" :state="errors.length > 0 ? false : null" required />
              <small v-if="errors.length" class="text-danger text-end">{{
                errors[0]
              }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="Status" label-for="employmentstatus">
            <validation-provider rules="required" #default="{ errors }" name="status">
              <b-form-select id="employmentstatus" :options="employementStatus"
                v-model="employementDetail.employmentStatus" :disabled="!isEdit"
                :state="errors.length > 0 ? false : null" required />

              <small v-if="errors.length" class="text-danger text-end">{{
                errors[0]
              }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="Employee Type*" label-for="employeeType">
            <validation-provider rules="required" #default="{ errors }" name="type">
              <b-form-select id="employeeType" :options="optionemployeeType"
                v-model="employementDetail.employeeType" :disabled="!isEdit"
               required />

              <small v-if="errors.length" class="text-danger text-end">{{
                errors[0]
              }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</template>

<script>
import { options } from "@braid/vue-formulate";
import {
  BFormFile,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BAlert,
  BCard,
  BCardText,
  BMedia,
  BMediaAside,
  BMediaBody,
  BLink,
  BImg,
  BAvatar,
  BFormSelect,
  BFormSelectOption,
  BFormDatepicker,
} from "bootstrap-vue";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css"; // Import styles
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import employee from "@/store/employee";

export default {
  components: {
    BButton,
    BForm,
    BImg,
    BFormFile,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BAlert,
    BCard,
    BCardText,
    BMedia,
    BMediaAside,
    BMediaBody,
    BLink,
    BAvatar,
    BFormSelect,
    BFormSelectOption,
    BFormDatepicker, ValidationProvider, ValidationObserver,
    DatePicker
  },
  props: {
    employementDetail: {
      type: Object,
      default: () => ({}),
    },
    managerList: {
      type: Array,
      default: () => ({}),
    },
  },
  data() {
    return {
      required,
      isEdit: false,
      disableFutureDates(date) {
      return date > new Date(); // Disables future dates
    },
      maxDate: new Date().toISOString().split('T')[0],
      employementStatus: [
        { text: "Employed", value: "EMPLOYED" },
        { text: "Resigned", value: "RESIGNED" },
        { text: "Terminated", value: "TERMINATED" },
      ],
      optionemployeeType: [
        { text: "Full Time", value: "FULLTIME" },
        { text: "Part Time", value: "PARTTIME" },
        { text: "Expatriate", value: "EXPAT" },
        { text: "Casual", value: "CASUAL" },
        { text: "Intern", value: "INTERN" },
        { text: "Probation", value: "PROBATION" },
        { text: "On contract", value: "CONTRACT" },


      ],
      employementDetails: {
        designationId: null,
        departmentId: null,
        hireDate: null,
        employmentStatus: "EMPLOYED",
        employeeType: "FullTime",
        salary: 0,
        managerId: null,
        notes: null,
      },
      managerOptions: [],
      departmentOptions: [],
      designationOptions: [],
    };
  },
  computed: {
    ...mapGetters("employeeModule", {
      employees: "employees",
    }),
    ...mapGetters("departmentModule", {
      departmentList: "departments",
    }),
    ...mapGetters("designationModule", {
      designationList: "designations",
    }),
  },
  methods: {
    checkEditMode() {
      const currentPath = this.$route.path.toLowerCase();
      this.isEdit = !currentPath.includes("/view/");
    },
    ...mapActions("employeeModule", ["getEmployeeListAction"]),
    ...mapActions("departmentModule", ["getDepartmentListAction"]),
    ...mapActions("designationModule", ["getDesignationListAction"]),
    resetForm() { },
    async submitDetailsForm() {
      const isValid = await this.$refs.employeeDetailsValidation.validate();
      console.log("employeeDetailsValidation emitted: ", isValid);
      // if (isValid) {
      //   this.$emit("employeeDetailsValidation", this.employementDetail);
      // }
      if (isValid) {
        // Ensure employeeType is included in the emitted data
        const formData = {
          ...this.employementDetail,
          employeeType: this.employementDetail.employeeType,
        };
        this.$emit("employeeDetailsValidation", formData);
      }
      return isValid;
    },
    // Add a method to handle employee type changes
    handleEmployeeTypeChange(value) {
      this.employementDetail.employeeType = value;
      this.$emit("updateEmployement", this.employementDetail);
    },
  },
  async mounted() {
    this.checkEditMode();

  // Load departments
  await this.getDepartmentListAction().then(() => {
    this.departmentOptions = this.departmentList.map(v => ({
      text: v.departmentName,
      value: v.departmentId,
    }));
  });

  // Load designations
  await this.getDesignationListAction().then(() => {
    this.designationOptions = this.designationList.map(v => ({
      text: v.designationName,
      value: v.id,
    }));

    // Ensure correct filtering of designations based on department
    if (this.employementDetail.departmentId) {
      this.designationOptions = this.designationList
        .filter(designation => designation.departmentId === this.employementDetail.departmentId)
        .map(designation => ({
          text: designation.designationName,
          value: designation.id,
        }));
    }

    console.log("Designation List Loaded:", this.designationOptions);
  });

  // Load managers
  this.managerOptions = this.managerList.map(v => ({
    text: `${v.firstName} ${v.lastName}`,
    value: v.id,
  }));
  },
  // setup() {
  //   const refInputEl = ref(null);
  //   const previewEl = ref(null);

  //   const { inputImageRenderer } = useInputImageRenderer(refInputEl, previewEl);

  //   return {
  //     refInputEl,
  //     previewEl,
  //     inputImageRenderer,
  //   };
  // },
  watch: {
    $route: "checkEditMode",
    // Watch for changes to the individual object
    "employementDetail.departmentId": {
    handler(newDepartmentId) {
      if (newDepartmentId) {
        // Ensure designationList is populated before filtering
        if (this.designationList.length > 0) {
          this.designationOptions = this.designationList
            .filter(designation => designation.departmentId === newDepartmentId) // Filter designations
            .map(designation => ({
              text: designation.designationName,
              value: designation.id,
            }));
        }
      } else {
        this.designationOptions = []; // Clear if no department is selected
      }

      console.log("Filtered Designation Options:", this.designationOptions);
    },
    immediate: true, // Run immediately when component is mounted
  },
},
};
</script>
